/** 分包 AppInfo 缓存（localStorage；按子域名隔离 origin，无需拼 appId） */
export const STORAGE_KEY_APP_BRANDING = 'h5r_app_branding';

export const STORAGE_KEY_DEVICE_INFO = 'storage_key_device_info';

/** POST /device/register/v1 请求体 device_uuid */
export const STORAGE_KEY_DEVICE_UUID = 'h5r_device_uuid';
/** POST /device/register/v1 请求体 install_seq */
export const STORAGE_KEY_INSTALL_SEQ = 'h5r_install_seq';
/** 服务端注册返回的 device_id，作业务通参（三级存储） */
export const STORAGE_KEY_TOURIST_DEVICE_ID = 'h5r_tourist_device_id';
/** 业务服务端返回的正式登陆的 device_id，作业务通参（三级存储） */
export const STORAGE_KEY_SERVER_DEVICE_ID = 'h5r_server_device_id';
/** signInWithRedirect 跳走前写入，回跳后首帧可展示 loading（与 h5-hybrid 一致） */
export const SESSION_KEY_FIREBASE_LOGIN_PENDING = 'firebase_login_pending';
/** 与 PENDING 同时写入，登录成功后 router.replace 的目标（pathname + search） */
export const SESSION_KEY_FIREBASE_LOGIN_RETURN_TO = 'firebase_login_return_to';
/** OAuth 发起时写入，回跳后 LOGIN_RESULT 与 LOGIN_CLICK 对齐（URL 回跳后常无 query） */
export const SESSION_KEY_FIREBASE_LOGIN_TRIGGER_SCENE = 'firebase_login_trigger_scene';

/** OAuth 发起时写入登录方式（google/facebook），回跳后用于登录链路埋点归因 */
export const SESSION_KEY_FIREBASE_LOGIN_METHOD = 'firebase_login_method';

/** OAuth 跳走前快照的落地五参；Facebook 跨 tab 回跳需 localStorage（与 login_method 同域共享） */
export const STORAGE_KEY_FIREBASE_LOGIN_DYE_PARAMS = 'firebase_login_dye_params';

/** 前端可读 cookie：postLogin 成功后写入，供 waitForSession 首帧 0 等待（非鉴权 token） */
export const STORAGE_KEY_SESSION_READY = 'h5r_session_ready';

/** 发现页列表缓存（sessionStorage，存 JSON）Tab 切换返回时直接复用 避免首屏空白 */
export const SESSION_KEY_DISCOVER_CACHE = 'h5r_discover_cache';

/** 搜索页历史关键词（localStorage） */
export const STORAGE_KEY_SEARING_SEARCH_HISTORY = 'h5_reader_searing_search_history_v1';

/** 阅读器本地进度（localStorage） */
export const STORAGE_KEY_READER_BOOK_LOCAL = 'reader_book_local_v1';

/** 阅读器首进性能：入口 URL 快照（落地剥参后仍保留 is_from_landing 等） */
export const SESSION_KEY_READER_PERF_ENTRY = 'h5r_reader_perf_entry';

/** 阅读器入口 module_name 缓存（sessionStorage）：支付回跳后 query 被剥时供埋点兜底 */
export const SESSION_KEY_READER_MODULE_NAME = 'h5r_reader_module_name';

/** H5 路由性能（@/utils/performance-log）：当前 app_version 下已上报过性能的路由 pathname 集合（JSON） */
export const STORAGE_KEY_H5_PERF_ROUTE_VERSION_SEEN = 'h5_perf_route_version_seen';
/** Hosted Checkout 跳转前写入 return_url（已合并落地五参）+ 五参快照；回跳 query 被剥时用于同源 replace 恢复（PayPal / Stripe 订阅共用） */
export const SESSION_KEY_HOSTED_CHECKOUT_PENDING_RETURN = 'paypal_pay_pending_return';
/** Hosted Checkout 成功回站后，用于在正文渲染完成时定位已解锁章节。 */
export const SESSION_KEY_HOSTED_CHECKOUT_SUCCESS_CHAPTER = 'paypal_pay_success_chapter';

/** user_referer 埋点是否已上报（localStorage，设备维度仅一次） */
export const STORAGE_KEY_USER_REFERER_REPORTED = 'h5r_user_referer_reported';
/** dyeing_did 埋点是否已上报（localStorage，设备维度仅一次） */
export const STORAGE_KEY_DYEING_DID_REPORTED = 'h5r_dyeing_did_reported';
/**
 * 当前 tab 会话内已上报过的 landing_timestamp 值（sessionStorage）。
 * 用于：复制打开上报一次；原地刷新 / 同会话 SPA 跳转不重复报；本机刚写入标记时也记入以免误报。
 */
export const SESSION_KEY_LANDING_TIMESTAMP_REPORTED = 'h5r_landing_timestamp_reported';
/** /pay 入口 trigger_scene；PayPal 回跳 URL 无 trigger 时供 handleBack 返回来源页 */
export const SESSION_KEY_PAY_PAGE_TRIGGER_SCENE = 'pay_page_trigger_scene';
/** PayPal 取消原因弹窗上次展示时间（localStorage，ms 时间戳） */
export const STORAGE_KEY_PAYPAL_CANCEL_REASON_LAST_SHOWN_AT = 'h5r_paypal_cancel_reason_last_shown_at';
/** PayPal checkout 跳转前写入的 pending meta（sessionStorage，key 后缀为 orderId） */
export const SESSION_KEY_PAYPAL_PAY_META_PREFIX = 'paypal_pay_meta_';
/** 兼容旧版订阅跳转写入的 pending meta */
export const SESSION_KEY_PAYPAL_SUBS_META_PREFIX = 'paypal_subs_meta_';

export function getPayPalPayMetaSessionKey(orderId: string): string {
    return `${SESSION_KEY_PAYPAL_PAY_META_PREFIX}${orderId}`;
}

export function getPayPalSubsMetaSessionKey(orderId: string): string {
    return `${SESSION_KEY_PAYPAL_SUBS_META_PREFIX}${orderId}`;
}
/** 用户上次手动选择的支付方式（localStorage，按设备持久化） */
export const STORAGE_KEY_LAST_PAY_METHOD = 'h5r_last_pay_method';

/** 后端泳道（localStorage，非线上调试；请求头 x-env） */
export const STORAGE_KEY_BACKEND_SWIMLANE = 'h5r_backend_swimlane';

/** 付费墙「假头像 + 已购人数」社会证明：按书缓存随机头像组合与购买人数（localStorage，JSON，LRU 上限 100 本） */
export const STORAGE_KEY_PAYWALL_PURCHASE_PROOF = 'h5r_paywall_purchase_proof_v1';
